import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'

// Fetch MFA status
export const fetchSecurityStatus = () => async (dispatch) => {
  dispatch({ type: ActionTypes.SECURITY_FETCH_STATUS_LOAD })
  try {
    const result = await api.get('totp/status')
    dispatch({
      type: ActionTypes.SECURITY_FETCH_STATUS_SUCCEED,
      totpEnabled: result.totp_enabled,
      passkeyEnabled: result.passkey_enabled,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.SECURITY_FETCH_STATUS_FAIL,
      error: error.message,
    })
  }
}

// TOTP Setup
export const setupTotp = () => async (dispatch) => {
  dispatch({ type: ActionTypes.SECURITY_TOTP_SETUP_LOAD })
  try {
    const result = await api.create('totp/setup', {})
    dispatch({
      type: ActionTypes.SECURITY_TOTP_SETUP_SUCCEED,
      secret: result.secret,
      otpauth: result.otpauth,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.SECURITY_TOTP_SETUP_FAIL,
      error: error.message,
    })
  }
}

// TOTP Verify and Enable
export const verifyTotp = (code) => async (dispatch) => {
  dispatch({ type: ActionTypes.SECURITY_TOTP_VERIFY_LOAD })
  try {
    await api.create('totp/verify', { code })
    dispatch({ type: ActionTypes.SECURITY_TOTP_VERIFY_SUCCEED })
    dispatch(fetchSecurityStatus())
  } catch (error) {
    dispatch({
      type: ActionTypes.SECURITY_TOTP_VERIFY_FAIL,
      error: error.message,
    })
  }
}

// TOTP Disable
export const disableTotp = (code) => async (dispatch) => {
  dispatch({ type: ActionTypes.SECURITY_TOTP_DISABLE_LOAD })
  try {
    await api.create('totp/disable', { code })
    dispatch({ type: ActionTypes.SECURITY_TOTP_DISABLE_SUCCEED })
    dispatch(fetchSecurityStatus())
  } catch (error) {
    dispatch({
      type: ActionTypes.SECURITY_TOTP_DISABLE_FAIL,
      error: error.message,
    })
  }
}

// Fetch Passkeys
export const fetchPasskeys = () => async (dispatch) => {
  dispatch({ type: ActionTypes.SECURITY_PASSKEY_LIST_LOAD })
  try {
    const result = await api.get('passkeys')
    dispatch({
      type: ActionTypes.SECURITY_PASSKEY_LIST_SUCCEED,
      passkeys: result.data,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.SECURITY_PASSKEY_LIST_FAIL,
      error: error.message,
    })
  }
}

// Add Passkey
export const addPasskey = (deviceName) => async (dispatch) => {
  dispatch({ type: ActionTypes.SECURITY_PASSKEY_ADD_LOAD })
  try {
    // Get registration options
    const options = await api.create('passkeys/registration-options', {})
    
    // Start WebAuthn registration
    const { startRegistration } = await import('@simplewebauthn/browser')
    const credential = await startRegistration(options)
    
    // Complete registration
    await api.create('passkeys/register', { credential, deviceName })
    
    dispatch({ type: ActionTypes.SECURITY_PASSKEY_ADD_SUCCEED })
    dispatch(fetchPasskeys())
    dispatch(fetchSecurityStatus())
  } catch (error) {
    dispatch({
      type: ActionTypes.SECURITY_PASSKEY_ADD_FAIL,
      error: error.message || 'Failed to add passkey',
    })
  }
}

// Delete Passkey
export const deletePasskey = (passkeyId) => async (dispatch) => {
  dispatch({ type: ActionTypes.SECURITY_PASSKEY_DELETE_LOAD })
  try {
    await api.delete(`passkeys/${passkeyId}`)
    dispatch({ type: ActionTypes.SECURITY_PASSKEY_DELETE_SUCCEED })
    dispatch(fetchPasskeys())
    dispatch(fetchSecurityStatus())
  } catch (error) {
    dispatch({
      type: ActionTypes.SECURITY_PASSKEY_DELETE_FAIL,
      error: error.message,
    })
  }
}

